import { render, staticRenderFns } from "./MultiStat.vue?vue&type=template&id=609a82b4&scoped=true"
import script from "./MultiStat.vue?vue&type=script&lang=js"
export * from "./MultiStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a82b4",
  null
  
)

export default component.exports